/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    import Directive = angular.IDirective;
    import ProcessDataNode = models.ProcessDataNode;
    import JsTreeNode = models.JSTreeNode;

    export class ProcessConfigurationTree implements Directive {
        public controller =
        [
            '$scope', 'processConfigurationService', "treeService", 'objectSchemaService',
            'constantService', 'systemLevelService', 'queryConfigurationService',
            'manageStaticDocumentsService', '$q', ProcessConfigurationTreeController
        ];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/processConfigurationTree.html';
        public restrict: string = "E";

        public scope: any = {
            configurationId: '=',
            reloadConfig: '=',
            reloadTree: '=',
            nodeSelectedCallback: '=',
            excludeItem: '=',
            includeTreeSections: '@',
            includedFormIds: '=',
            inputParameterSchema: '=',
            isReporting: '='
        };

        public link(scope: IProcessConfigurationTreeScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: ProcessConfigurationTreeController): void {
            scope.tree = {
                treeData: [],
                treeConfig: {
                    plugins: ['search'],
                    search: {
                        show_only_matches: true,
                        show_only_matches_children: true
                    }
                },
                searchString: ''
            };

            scope.changed = (e, data) => {
                if (data.action === "select_node") {
                    if (data.node.li_attr.warsInfo) {
                        var treeItem = JSON.parse(data.node.li_attr.warsInfo);
                        if (scope.nodeSelectedCallback) {
                            scope.nodeSelectedCallback(treeItem);
                        }
                    }
                }
            }

            scope.applySearch = () => {
                if (scope.treeInstance) {
                    scope.treeInstance.jstree(true).search(scope.tree.searchString);
                }
            };
        }

        public static encodeStringifiedTreeItem(stringified: string): string {
            return stringified.replace(/'+/g, "~~!!~~");
        }

        public static getDecodedTreeItem(clearAfterRetrival: boolean): models.TreeConfigurationItem {
            var localStorageValue = localStorage.getItem("treeDrag");
            if (localStorageValue === undefined || localStorageValue === null) return null;
            
            var decodedValue = localStorageValue.replace("~~!!~~", "'");
            var value = JSON.parse(decodedValue);

            if (clearAfterRetrival) {
                localStorage.setItem("treeDrag", null);
            }
            return value;
        }
    }

    export interface IProcessConfigurationTreeScope extends ng.IScope {
        configuration: Wars.Domain.Model.ProcessConfiguration;
        relatedClaimLookup: Wars.Domain.Model.Dtos.RelatedClaimDto[];

        systemLevel: Wars.Domain.Model.SystemLevel;

        systemQueries: Wars.Domain.Model.QueryConfiguration[];
        processQueries: Wars.Domain.Model.QueryConfiguration[];

        configurationId: string;
        reloadConfig: boolean;
        reloadTree: boolean;
        nodeSelectedCallback(treeItem: models.TreeConfigurationItem): void;
        refresh(): void;
        excludeItem: models.TreeConfigurationItem;
        tree: any;
        changed(event, data): void;
        includeTreeSections: string;
        includedFormIds: string[];
        inputParameterSchema: Wars.Domain.Model.ObjectSchema;
        applySearch: any;
        treeInstance: any;
        isReporting: boolean;
    }

    export class ProcessConfigurationTreeController implements IController {
        private restrictionsDefined: boolean = false;
        private systemSectionsAllowed: string[] = undefined;
        private processSectionAllowed: string[] = undefined;
        private treeLoaded: boolean;

        constructor(
            private scope: IProcessConfigurationTreeScope,
            private processConfigurationService: services.ProcessConfigurationService,
            private treeService: services.TreeService,
            private objectSchemaService: services.ObjectSchemaService,
            private constantService: services.ConstantService,
            private systemLevelService: services.SystemLevelService,
            private queryConfigurationService: services.QueryConfigurationService,
            private staticDocumentService: services.ManageStaticDocumentsService,
            private $q: angular.IQService)
        {
            this.scope = scope;
            this.treeLoaded = false;

            var self = this;

            scope.$watch("configurationId", () => {
                this.loadProcessConfiguration();
            });

            scope.$watch("reloadConfig", (newValue: boolean) => {
                if (newValue) {
                    this.loadProcessConfiguration();
                    scope.reloadConfig = false;
                }
            });

            scope.$watch("reloadTree", (newValue: boolean) => {
                if (newValue) {
                    if (self.treeLoaded) this.createTreeData();
                    scope.reloadTree = false;
                }
            });

            scope.refresh = () => {
                this.loadProcessConfiguration();
            }

            this.setIncludedSections();
        }

        private setIncludedSections(): void {
            if (this.scope.includeTreeSections && this.scope.includeTreeSections !== "") {
                this.restrictionsDefined = true;
                var split = this.scope.includeTreeSections.split(' ');
                for (let i = 0; i < split.length; i++) {
                    var internalSplit = split[i].split('.');
                    if (internalSplit && internalSplit.length > 0 && internalSplit[0] === "System") {
                        this.systemSectionsAllowed = internalSplit.length > 1 ? internalSplit.slice(1) : [];
                    }

                    if (internalSplit && internalSplit.length > 0 && internalSplit[0] === "Process") {
                        this.processSectionAllowed = internalSplit.length > 1 ? internalSplit.slice(1) : [];
                    }
                }
            }
        }

        private loadProcessConfiguration() {
            var self = this;

            var dataLoadPromises = [];

            // Process Level
            if (self.scope.configurationId && (this.isProcessTopLevelAllowed())) {

                var relatedClaimsDefer = this.$q.defer();
                this.treeService.getRelatedClaimLookup().then((relatedClaims) => {
                    this.scope.relatedClaimLookup = relatedClaims;
                    services.TreeService.relatedClaimLookup = relatedClaims;
                    relatedClaimsDefer.resolve();
                });
                dataLoadPromises.push(relatedClaimsDefer.promise);

                var processConfigDefer = this.$q.defer();

                this.processConfigurationService.getProcessConfigurationForTree(self.scope.configurationId).then(
                    (appConfig) => {
                        self.scope.configuration = appConfig;

                        if (this.isProcessSectionAllowed("Variables")) {
                            self.objectSchemaService.getObjectSchemaExpanded(self.scope.configuration.processDataSchema_id).then(
                                (processDataSchema) => {
                                    self.scope.configuration.processDataSchema = processDataSchema;
                                    processConfigDefer.resolve();
                                });
                        } else {
                            processConfigDefer.resolve();
                        }
                    });
                dataLoadPromises.push(processConfigDefer.promise);

                if (this.isProcessSectionAllowed("Queries")) {
                    var processQueryPromise = this.queryConfigurationService.getAllQueryConfigurations(self.scope.configurationId).then(
                        queryConfigs => {
                            self.scope.processQueries = queryConfigs;
                        });
                    dataLoadPromises.push(processQueryPromise);
                }
            }

            // System Level
            if (this.isSystemTopLevelAllowed()) {

                var systemLevelPromise = this.$q.defer();

                this.systemLevelService.getMostSystemLevelInfo().then(
                    (systemLevel) => {
                        if (self.scope.systemLevel === undefined || self.scope.systemLevel === null) {
                            self.scope.systemLevel = systemLevel;
                        }

                        self.objectSchemaService.getObjectSchemaExpanded(systemLevel.variableSchema_id).then(
                            (variableSchema) => {
                                self.scope.systemLevel.variableSchema = variableSchema;
                                systemLevelPromise.resolve();
                            });
                    });

                dataLoadPromises.push(systemLevelPromise.promise);

                if (this.isSystemSectionAllowed("CodeGroups")) {
                    var systemLevelCodePromise = this.$q.defer();

                    this.systemLevelService.getSystemLevelCodes().then((systemLevel) => {
                        if (self.scope.systemLevel === undefined || self.scope.systemLevel === null) {
                            self.scope.systemLevel = systemLevel;
                        } else {
                            self.scope.systemLevel.myCodeGroups = systemLevel.myCodeGroups;
                        }
                        systemLevelCodePromise.resolve();
                    });

                    dataLoadPromises.push(systemLevelCodePromise.promise);
                }

                if (this.isSystemSectionAllowed("Queries")) {
                    var systemQueryPromise = this.queryConfigurationService.getAllQueryConfigurations(null).then(
                        queryConfigs => {
                            self.scope.systemQueries = queryConfigs;
                        });
                    dataLoadPromises.push(systemQueryPromise);
                }

            } else {
                this.systemLevelService.getSystemLevelClaims().then(
                    (systemLevel) => {
                        self.scope.systemLevel = systemLevel;
                    });
            }

            this.$q.all(dataLoadPromises).then(() => {
                this.createTreeData();
            });
        }

        public createTreeData() {
            var processConfig = this.scope.configuration;

            this.scope.tree.treeData = [];

            if (this.scope.inputParameterSchema && this.scope.inputParameterSchema.properties && this.scope.inputParameterSchema.properties.length > 0) {
                var inputTopNode = this.getTopNode("Input Parameters", true);
                this.setSchemaNodes(this.scope.inputParameterSchema, inputTopNode, undefined, Wars.Domain.Model.Codes.Enums.TreeItemSource.OperationParameter, false, "glyphicon-hand-right");
                this.scope.tree.treeData.push(inputTopNode);
            }

            if (this.isSystemTopLevelAllowed()) {
                var systemTopNode = this.getTopNode("System", true);

                if (this.isSystemSectionAllowed("Placeholders")) {
                    var systemPlaceholdersTopNode = this.getTopNode("Placeholders", false);

                    this.setPlaceHolderValues(systemPlaceholdersTopNode, true);

                    systemTopNode.children.push(systemPlaceholdersTopNode);
                }

                if (this.isSystemSectionAllowed("Calculations")) {

                    var systemCalculationsTopNode = this.getTopNode("Calculations", false);

                    if (this.scope.systemLevel.myCalculations) {
                        let orderedSystemCalculations = Enumerable.from(this.scope.systemLevel.myCalculations).orderBy(i => i.name).toArray();
                        for (let x = 0; x < orderedSystemCalculations.length; x++) {
                            if (this.scope.excludeItem && this.scope.excludeItem.calculationId === orderedSystemCalculations[x].id) continue;
                            systemCalculationsTopNode.children.push(this.constructTreeCalcuationNode(orderedSystemCalculations[x], true));
                        }
                    }

                    systemTopNode.children.push(systemCalculationsTopNode);
                }

                if (this.isSystemSectionAllowed("CodeGroups")) {

                    var systemCodeGroupsTopNode = this.getTopNode("Code Groups", false);

                    if (this.scope.systemLevel.myCodeGroups) {

                        var orderedSystemCodeGroups = Enumerable.from(this.scope.systemLevel.myCodeGroups)
                            .orderBy(codeGroup => codeGroup.groupName)
                            .toArray();

                        for (let x = 0; x < orderedSystemCodeGroups.length; x++) {
                            var codeGroupTopLevel = this.getTopNode(orderedSystemCodeGroups[x].groupName, false);
                            Enumerable.from(orderedSystemCodeGroups[x].codes).orderBy(code=>code.shortDescription).forEach(code => {
                                codeGroupTopLevel.children.push(this.constructTreeNodeForComplexGroupCode(code, Wars.Domain.Model.Codes.Enums.TreeItemSource.CodeGroup, true));
                            });
                            systemCodeGroupsTopNode.children.push(codeGroupTopLevel);
                        }
                    }

                    systemTopNode.children.push(systemCodeGroupsTopNode);
                }

                if (this.isSystemSectionAllowed("Constants")) {
                    var systemConstantsTopNode = this.getTopNode("Constants", false);

                    if (this.scope.systemLevel.myConstants) {
                        var orderedSystemConstants = Enumerable.from(this.scope.systemLevel.myConstants)
                            .orderBy(constant => constant.name)
                            .toArray();

                        for (let x = 0; x < orderedSystemConstants.length; x++) {
                            systemConstantsTopNode.children.push(this.constructTreeConstantNode(orderedSystemConstants[x], true));
                        }
                    }

                    systemTopNode.children.push(systemConstantsTopNode);
                }

                if (this.isSystemSectionAllowed("ClaimGroups")) {
                    var systemClaimGroupTopNode = this.getTopNode("Claim Group", false);
                    
                    this.setClaimGroupNodes(this.scope.systemLevel.myClaimGroups, systemClaimGroupTopNode, true);
                    systemTopNode.children.push(systemClaimGroupTopNode);
                }

                if (this.isSystemSectionAllowed("Claims")) {

                    var systemClaimTopNode = this.getTopNode("Claims", false);

                    var orderedSystemClaims = Enumerable.from(this.scope.systemLevel.myClaims)
                        .orderBy(claim => claim.type)
                        .toArray();

                    for (let i = 0; i < orderedSystemClaims.length; i++) {

                        if (this.scope.excludeItem && this.scope.excludeItem.claimId === orderedSystemClaims[i].id) continue;

                        var systemClaimOptions = new models.TreeItemOptions(
                            orderedSystemClaims[i].id,
                            orderedSystemClaims[i].type,
                            Wars.Domain.Model.Codes.Enums.TreeItemSource.Claim,
                            Wars.Domain.Model.Codes.Enums.VariableType.Claim,
                            true);
                        systemClaimOptions.isClaimWithValue = orderedSystemClaims[i].valueType !== null &&
                            orderedSystemClaims[i].valueType !== Wars.Domain.Model.Codes.Enums.VariableType.None

                        var systemClaimItemStr: string = this.getTreeItemString(systemClaimOptions);

                        var systemClaimNode = this.getNode(orderedSystemClaims[i].type, systemClaimItemStr, "glyphicon-lock", null, null);

                        systemClaimTopNode.children.push(systemClaimNode);
                    }
                    systemTopNode.children.push(systemClaimTopNode);
                }

                if (this.isSystemSectionAllowed("StaticDocuments")) {
                    var staticDocumentsTopNode = this.getTopNode("Documents", false);

                    this.setStaticDocumentNodes(this.scope.systemLevel.myStaticDocuments, staticDocumentsTopNode, true);
                    systemTopNode.children.push(staticDocumentsTopNode);
                }

                if (this.isSystemSectionAllowed("EmailGroups")) {
                    var systemEmailGroupsTopNode = this.getTopNode("Email Groups", false);
                    this.setEmailGroupNodes(this.scope.systemLevel.myEmailGroups, systemEmailGroupsTopNode, true);
                    systemTopNode.children.push(systemEmailGroupsTopNode);
                }

                if (this.isSystemSectionAllowed("Variables")) {
                    var systemVariablesTopNode = this.getTopNode("Variables", false);
                    this.setSchemaNodes(this.scope.systemLevel.variableSchema, systemVariablesTopNode, undefined, Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable, true, "glyphicon-floppy-disk");
                    systemTopNode.children.push(systemVariablesTopNode);
                }

                if (this.isSystemSectionAllowed("Queries")) {
                    var systemQueriesTopNode = this.getTopNode("Queries", false);

                    this.setQueryNodes(this.scope.systemQueries, systemQueriesTopNode, true);
                    systemTopNode.children.push(systemQueriesTopNode);
                }

                if (this.isSystemSectionAllowed("TimeTrackers")) {

                    var systemTimeTrackerTopNode = this.getTopNode("Time Trackers", false);

                    var orderedSystemTimeTrackers = Enumerable.from(this.scope.systemLevel.myTimeTrackers)
                        .orderBy(i => i.name)
                        .toArray();

                    for (let i = 0; i < orderedSystemTimeTrackers.length; i++) {
                        var systemClockOptions = new models.TreeItemOptions(
                            orderedSystemTimeTrackers[i].id,
                            orderedSystemTimeTrackers[i].name,
                            Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker,
                            Wars.Domain.Model.Codes.Enums.VariableType.TimeTracker,
                            false);

                        var systemClockStringified: string = this.getTreeItemString(systemClockOptions);

                        var systemTimeTrackerNode = this.getNode(orderedSystemTimeTrackers[i].name, systemClockStringified, "glyphicon-superscript", null, null);

                        systemTimeTrackerTopNode.children.push(systemTimeTrackerNode);
                    }


                    systemTopNode.children.push(systemTimeTrackerTopNode);
                }

                this.scope.tree.treeData.push(systemTopNode);
            }

            if (processConfig) {

                if (this.isProcessTopLevelAllowed()) {

                    var processTopNode = this.getTopNode("Process", true);

                    if (this.isProcessSectionAllowed("Placeholders")) {
                        var placeholdersTopNode = this.getTopNode("Placeholders", false);

                        this.setPlaceHolderValues(placeholdersTopNode, false);

                        processTopNode.children.push(placeholdersTopNode);
                    }

                    if (this.isProcessSectionAllowed("Calculations")) {

                        var calculationsTopNode = this.getTopNode("Calculations", false);

                        if (processConfig.myCalculations) {
                            let orderedCalculations = Enumerable.from(processConfig.myCalculations)
                                .orderBy(calc => calc.name)
                                .toArray();

                            for (let x = 0; x < orderedCalculations.length; x++) {
                                if (this.scope.excludeItem && this.scope.excludeItem.calculationId === orderedCalculations[x].id) continue;
                                calculationsTopNode.children.push(this.constructTreeCalcuationNode(orderedCalculations[x], false));
                            }
                        }

                        processTopNode.children.push(calculationsTopNode);
                    }

                    if (this.isProcessSectionAllowed("TimeTrackers")) {

                        var timeTrackerTopNode = this.getTopNode("Time Trackers", false);

                        var orderedProcessTimeTrackers = Enumerable.from(processConfig.myTimeTrackerContainers)
                            .select(tt => tt.myTimeTracker)
                            .orderBy(tt => tt.name)
                            .toArray();

                        for (let i = 0; i < orderedProcessTimeTrackers.length; i++) {
                            var clockOptions = new models.TreeItemOptions(
                                orderedProcessTimeTrackers[i].id,
                                orderedProcessTimeTrackers[i].name,
                                Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker,
                                Wars.Domain.Model.Codes.Enums.VariableType.TimeTracker,
                                false);

                            var clockStringified: string = this.getTreeItemString(clockOptions);

                            var timeTrackerNode = this.getNode(orderedProcessTimeTrackers[i].name, clockStringified, "glyphicon-superscript", null, null);

                            timeTrackerTopNode.children.push(timeTrackerNode);
                        }
                        

                        processTopNode.children.push(timeTrackerTopNode);
                    }

                    if (this.isProcessSectionAllowed("Claims")) {

                        var claimTopNode = this.getTopNode("Claims", false);

                        var orderedProcessClaims = Enumerable.from(processConfig.myClaims)
                            .orderBy(claim => claim.type)
                            .toArray();

                        for (let i = 0; i < orderedProcessClaims.length; i++) {

                            if (this.scope.excludeItem && this.scope.excludeItem.claimId === orderedProcessClaims[i].id) continue;

                            var claimItemOptions = new models.TreeItemOptions(
                                orderedProcessClaims[i].id,
                                orderedProcessClaims[i].type,
                                Wars.Domain.Model.Codes.Enums.TreeItemSource.Claim,
                                Wars.Domain.Model.Codes.Enums.VariableType.Claim,
                                false);
                            claimItemOptions.isClaimWithValue = orderedProcessClaims[i].valueType !== null &&
                                orderedProcessClaims[i].valueType !== Wars.Domain.Model.Codes.Enums.VariableType.None

                            var claimItemStr: string = this.getTreeItemString(claimItemOptions);

                            var claimNode = this.getNode(orderedProcessClaims[i].type, claimItemStr, "glyphicon-lock", null, null);

                            claimTopNode.children.push(claimNode);
                        }
                        processTopNode.children.push(claimTopNode);
                    }

                    if (this.isProcessSectionAllowed("RelatedClaims")) {

                        var relatedClaimTopNode = this.getTopNode("Related Claims", false);

                        for (let relatedClaimProcessTypeIndex = 0; relatedClaimProcessTypeIndex < processConfig.myRelatedClaimProcessTypes.length; relatedClaimProcessTypeIndex++) {

                            var relatedClaimProcessType = processConfig.myRelatedClaimProcessTypes[relatedClaimProcessTypeIndex];

                            for (let relatedClaimIndex = 0; relatedClaimIndex < relatedClaimProcessType.relatedClaims.length; relatedClaimIndex++) {

                                var relatedClaim = relatedClaimProcessType.relatedClaims[relatedClaimIndex];
                                var relatedClaimName = Enumerable.from(this.scope.relatedClaimLookup)
                                    .first(i => i.uniqueIdentifier === relatedClaim.claimUniqueId).claimName;

                                let relatedClaimItemOptions = new models.TreeItemOptions(
                                    relatedClaimProcessType.id,
                                    relatedClaimName,
                                    Wars.Domain.Model.Codes.Enums.TreeItemSource.RelatedClaim,
                                    Wars.Domain.Model.Codes.Enums.VariableType.Claim,
                                    false);

                                // TODO: Fix this when we have a need for a related claim with a value
                                relatedClaimItemOptions.isClaimWithValue = false;

                                relatedClaimItemOptions.claimUniqueId = relatedClaim.claimUniqueId;

                                let relatedClaimItemStr: string = this.getTreeItemString(relatedClaimItemOptions);

                                let relatedClaimNode = this.getNode(relatedClaimName,
                                    relatedClaimItemStr,
                                        "glyphicon-lock",
                                        null,
                                        null);

                                relatedClaimTopNode.children.push(relatedClaimNode);
                            }
                        }
                        processTopNode.children.push(relatedClaimTopNode);
                    }

                    if (this.isProcessSectionAllowed("CodeGroups")) {

                        var codeGroupsTopNode = this.getTopNode("Code Groups", false);

                        if (processConfig.myCodeGroups) {
                            var orderedProcessCodeGroups = Enumerable.from(processConfig.myCodeGroups)
                                .orderBy(codeGroup => codeGroup.groupName)
                                .toArray();

                            for (let x = 0; x < orderedProcessCodeGroups.length; x++) {
                                var codeGroupNode = this.getTopNode(orderedProcessCodeGroups[x].groupName, false);
                                Enumerable.from(orderedProcessCodeGroups[x].codes).orderBy(code=> code.shortDescription).forEach(code => {
                                    codeGroupNode.children.push(this.constructTreeNodeForComplexGroupCode(code, Wars.Domain.Model.Codes.Enums.TreeItemSource.CodeGroup, false));
                                });

                                codeGroupsTopNode.children.push(codeGroupNode);
                            }
                        }

                        processTopNode.children.push(codeGroupsTopNode);
                    }

                    if (this.isProcessSectionAllowed("Conditions")) {

                        var conditionsTopNode = this.getTopNode("Conditions", false);

                        if (processConfig.myConditions) {
                            var orderedProcessConditions = Enumerable.from(processConfig.myConditions)
                                .orderBy(cond => cond.name)
                                .toArray();

                            for (let x = 0; x < orderedProcessConditions.length; x++) {
                                if (this.scope.excludeItem && this.scope.excludeItem.conditionId === orderedProcessConditions[x].id) continue;
                                conditionsTopNode.children.push(this.constructTreeConditionNode(orderedProcessConditions[x], false));
                            }
                        }

                        processTopNode.children.push(conditionsTopNode);
                    }

                    if (this.isProcessSectionAllowed("Constants")) {

                        var constantsTopNode = this.getTopNode("Constants", false);

                        if (processConfig.myConstants) {
                            var orderedProcessConstants = Enumerable.from(processConfig.myConstants)
                                .orderBy(i => i.name)
                                .toArray();

                            for (let x = 0; x < orderedProcessConstants.length; x++) {
                                constantsTopNode.children.push(this.constructTreeConstantNode(orderedProcessConstants[x], false));
                            }
                        }
                        processTopNode.children.push(constantsTopNode);
                    }
                    if (this.isProcessSectionAllowed("StaticDocuments")) {
                        var staticDocumentTopNode = this.getTopNode("Documents", false);
                        this.setStaticDocumentNodes(this.scope.configuration.myStaticDocuments, staticDocumentTopNode, false);
                        processTopNode.children.push(staticDocumentTopNode);
                    }

                    if (this.isProcessSectionAllowed("EmailGroups")) {
                        var processEmailGroupsTopNode = this.getTopNode("Email Groups", false);
                        this.setEmailGroupNodes(this.scope.configuration.myEmailGroups, processEmailGroupsTopNode, false);
                        processTopNode.children.push(processEmailGroupsTopNode);
                    }

                    if (this.isProcessSectionAllowed("Form")) {
                        let formTopNode = this.getTopNode("Forms", false);


                        var self = this;
                        var forms = Enumerable.from(processConfig.myForms).orderBy(i => i.name);

                        forms.forEach(form => {
                            if (self.scope.includedFormIds && self.scope.includedFormIds.length > 0 &&
                                !Enumerable.from(self.scope.includedFormIds).any(f => f === form.id)) {
                                return;
                            }

                            if (form.formType === Wars.Domain.Model.Codes.Enums.FormType.Manage) return;

                            let formId = form.id;
                            let formNode = this.getTopNode(form.name, false);

                            var steps = Enumerable.from(form.formSchema.properties).orderBy(i => i.typeSchema !== null ? i.typeSchema.name : i.name);

                            steps.forEach(property => {
                                if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Object ||
                                    property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List) {

                                    if (property.typeSchema == null) return;

                                    let stepNode = this.getTopNode(property.typeSchema.name, false);

                                    var sections = Enumerable.from(property.typeSchema.properties).orderBy(i => i.typeSchema !== null ? i.typeSchema.name : i.name);
                                    sections.forEach(sectionProperty => {

                                        let listSectionId = sectionProperty.objectSchema_id;

                                        if (sectionProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Object || 
                                            sectionProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List) {
                                            let groupNode = this.getTopNode(sectionProperty.typeSchema.name, false);

                                            var fields = Enumerable.from(sectionProperty.typeSchema.properties)
                                                .where(i => i.propertyType !== Wars.Domain.Model.Codes.Enums.VariableType.None)
                                                .orderBy(i => i.name);

                                            fields.forEach(fieldProp => {
                                                if (!this.scope.isReporting || (this.scope.isReporting && fieldProp.isIndexed)) {

                                                    let fieldNode = this.constructTreePropertySchemaNode(
                                                        fieldProp,
                                                        sectionProperty.typeSchema.isList ? listSectionId : undefined,
                                                        Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField,
                                                        false,
                                                        formId);

                                                    groupNode.children.push(fieldNode);
                                                }
                                            });

                                            stepNode.children.push(groupNode);
                                        } else {
                                            if (!this.scope.isReporting || (this.scope.isReporting && sectionProperty.isIndexed)) {

                                                let fieldNode = this.constructTreePropertySchemaNode(
                                                    sectionProperty,
                                                    property.typeSchema.isList ? listSectionId : undefined,
                                                    Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField,
                                                    false,
                                                    formId);

                                                stepNode.children.push(fieldNode);
                                            }
                                        }
                                    });

                                    formNode.children.push(stepNode);
                                } else {

                                    let fieldNode = this.constructTreePropertySchemaNode(
                                        property,
                                        undefined,
                                        Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField,
                                        false,
                                        formId);

                                    formNode.children.push(fieldNode);
                                }
                            });

                            //for (let i = 0; i < form.formSchema.properties.length; i++) {
                            //    var stepItemStr: string = this.getTreeItemString(form.mySteps[i].id, form.mySteps[i].objectSchema.name, Wars.Domain.Model.Codes.Enums.TreeItemSource.Step);
                            //    var node = this.getNode(form.mySteps[i].objectSchema.name, stepItemStr, "glyphicon-signal", null, null);

                            //    formNode.children.push(node);
                            //}

                            formTopNode.children.push(formNode);
                        });

                        processTopNode.children.push(formTopNode);
                    }

                    if (this.isProcessSectionAllowed("InterProcessApi")) {
                        var interProcessApiTopNode = this.getTopNode("Inter-Process APIs", false);


                        for (var i = 0; i < this.scope.configuration.myInterProcessApis.length; i++) {
                            var currentInterProcessApi = this.scope.configuration.myInterProcessApis[i];
                            var apiTopNode = this.getTopNode(currentInterProcessApi.name, false);
                            interProcessApiTopNode.children.push(apiTopNode);

                            this.setSchemaNodes(
                                currentInterProcessApi.myOutputSchema,
                                apiTopNode,
                                undefined,
                                Wars.Domain.Model.Codes.Enums.TreeItemSource.InterProcessApi,
                                false,
                                "glyphicon glyphicon-road",
                                currentInterProcessApi.id);
                        }
                        processTopNode.children.push(interProcessApiTopNode);
                    }

                    if (this.isProcessSectionAllowed("Queries")) {

                        var queryTopNode = this.getTopNode("Queries", false);
                        this.setQueryNodes(this.scope.processQueries, queryTopNode, false);
                        processTopNode.children.push(queryTopNode);
                    }

                    if (this.isProcessSectionAllowed("Variables")) {
                        var processDataTopNode = this.getTopNode("Variables", false);
                        this.setSchemaNodes(this.scope.configuration.processDataSchema, processDataTopNode, undefined, Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable, false, "glyphicon-floppy-disk");
                        processTopNode.children.push(processDataTopNode);
                    }

                    this.scope.tree.treeData.push(processTopNode);
                }
            }

            if (this.scope.tree.treeConfig.version) {
                this.scope.tree.treeConfig.version++;
            } else {
                this.scope.tree.treeConfig.version = 1;
            }

            this.treeLoaded = true;
        }

        private constructTreeQueryDataNode(property: Wars.Domain.Model.SchemaProperty, queryConfigurationId: string, listSectionId: string, isSystemLevel: boolean) {

            var queryDataOptions = new models.TreeItemOptions(
                property.id,
                property.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.Query,
                property.propertyType,
                isSystemLevel);

            queryDataOptions.listSectionId = listSectionId;
            queryDataOptions.queryConfigurationId = queryConfigurationId

            var queryDataStringified: string = this.getTreeItemString(queryDataOptions);

            return this.getNode(property.name, queryDataStringified, null, property.propertyType, null);
        }

        private constructTreePropertySchemaNode(
            property: Wars.Domain.Model.SchemaProperty,
            listSectionId: string,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource,
            isSystemLevel: boolean,
            formId?: string,
            interProcessApiId?: string): any
        {
            var options = new models.TreeItemOptions(
                property.id,
                property.name,
                treeItemSource,
                property.propertyType,
                isSystemLevel);

            options.listSectionId = listSectionId;
            options.interProcessApiId = interProcessApiId;
            options.isRequired = property.required;

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Code) {
                return this.constructTreeNodeForComplexCode(options);
            }

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.User) {
                return this.constructTreeNodeForComplexUser(options);
            }

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Status) {
                return this.constructTreeNodeForComplexStatus(options);
            }

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.State) {
                return this.constructTreeNodeForComplexState(options);
            }

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ScheduledResource) {
                return this.constructTreeNodeForComplexScheduledResource(options);
            }

            if (property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Time ||
                property.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {
                return this.constructTreeNodeForComplexDateTime(options);
            }

            var stringified: string = this.getTreeItemString(options);

            return this.getNode(property.name, stringified, null, property.propertyType, null);
        }

        private constructTreeNodeForComplexCode(options: models.TreeItemOptions): any
        {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelNode = this.getNode(options.text, topLevelString, null, options.variableType, null);

            var shortDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Short Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_ShortDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var shortDescriptionNode = this.getNode("Short Description", shortDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(shortDescriptionNode);

            var longDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Long Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_LongDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var longDescriptionNode = this.getNode("Long Description", longDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(longDescriptionNode);

            return topLevelNode;
        }

        private constructTreeNodeForComplexGroupCode(
            property: Wars.Domain.Model.Codes.SystemCode,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource,
            isSystemLevel: boolean): any {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                property.id,
                property.shortDescription,
                treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.Code,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_Id);

            var topLevelNode = this.getNode(property.shortDescription, topLevelString, null, Wars.Domain.Model.Codes.Enums.VariableType.Code, null);

            var shortDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                property.id,
                "Short Description",
                treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_ShortDescription);

            var shortDescriptionNode = this.getNode("Short Description", shortDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(shortDescriptionNode);

            var longDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                property.id,
                "Long Description",
                treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_LongDescription);

            var longDescriptionNode = this.getNode("Long Description", longDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(longDescriptionNode);

            return topLevelNode;
        }

        private constructTreeNodeForComplexUser(options: models.TreeItemOptions): any
        {
            var userTopLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var userTopLevelNode = this.getNode(options.text, userTopLevelString, null, options.variableType, null);

            var userNameString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Username",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_UserName,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var usernameNode = this.getNode("Username", userNameString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(usernameNode);

            var firstNameString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "First Name",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FirstName,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var firstNameNode = this.getNode("First Name", firstNameString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(firstNameNode);

            var middleNameString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Middle Name",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_MiddleName,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var middleNameNode = this.getNode("Middle Name", middleNameString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(middleNameNode);

            var lastNameString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Last Name",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_LastName,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var lastNameNode = this.getNode("Last Name", lastNameString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(lastNameNode);

            var fullNameString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Full Name",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FullName,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var fullNameNode = this.getNode("Full Name", fullNameString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(fullNameNode);

            var emailString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Email",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Email,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var emailNode = this.getNode("Email", emailString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(emailNode);

            var companyString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Company",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Company,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var companyNode = this.getNode("Company", companyString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(companyNode);

            var phoneNumberString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Phone Number",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_PhoneNumber,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var phoneNumberNode = this.getNode("Phone Number", phoneNumberString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(phoneNumberNode);

            var positionString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Position",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Position,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var positionNode = this.getNode("Position", positionString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(positionNode);


            var externalSystemIdentifierString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "External System Identifier",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ExternalSystemId,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var externalSystemIdentifierNode = this.getNode("External System Identifier", externalSystemIdentifierString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            userTopLevelNode.children.push(externalSystemIdentifierNode);

            var claimsString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Claims",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Claims,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var claimsNode = this.getNode("Claims", claimsString, null, Wars.Domain.Model.Codes.Enums.VariableType.List, null);
            userTopLevelNode.children.push(claimsNode);

            var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
                .where(i => i.codeGroup_id !== null)
                .toArray();

            if (claimsWithValues.length > 0) {

                var userClaimValueTopLevel = this.getTopNode("Claim Values", false);
                userTopLevelNode.children.push(userClaimValueTopLevel);
                
                for (var i = 0; i < claimsWithValues.length; i++) {
                    let claimValuesString: string = this.getTreeItemStringWithAllParmeters(
                        options.id,
                        claimsWithValues[i].type,
                        options.treeItemSource,
                        Wars.Domain.Model.Codes.Enums.VariableType.List,
                        options.isSystemLevel,
                        Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ClaimValues,
                        options.listSectionId,
                        options.isClaimWithValue,
                        options.queryConfigurationId,
                        options.placeholder,
                        options.isRequired,
                        options.isPlaceholderList,
                        claimsWithValues[i].id,
                        options.interProcessApiId);

                    var claimValuesNode = this.getNode(claimsWithValues[i].type, claimValuesString, null, Wars.Domain.Model.Codes.Enums.VariableType.List, null);
                    userTopLevelNode.children.push(claimValuesNode);
                }
            }

            return userTopLevelNode;
        }

        private constructTreeNodeForComplexStatus(options: models.TreeItemOptions): any {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelNode = this.getNode(options.text, topLevelString, null, options.variableType, null);

            var shortDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Short Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_ShortDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var shortDescriptionNode = this.getNode("Short Description", shortDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(shortDescriptionNode);

            var longDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Long Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_LongDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var longDescriptionNode = this.getNode("Long Description", longDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(longDescriptionNode);

            var effectiveDateNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Effective Date",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_EffectiveDate,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var effectiveDate = this.getNode("Effective Date", effectiveDateNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.DateTime, null);
            topLevelNode.children.push(effectiveDate);

            return topLevelNode;
        }

        private constructTreeNodeForComplexState(options: models.TreeItemOptions): any {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelNode = this.getNode(options.text, topLevelString, null, options.variableType, null);

            var shortDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Short Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_ShortDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var shortDescriptionNode = this.getNode("Short Description", shortDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(shortDescriptionNode);

            var longDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Long Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_LongDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var longDescriptionNode = this.getNode("Long Description", longDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelNode.children.push(longDescriptionNode);

            var effectiveDateNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Effective Date",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_EffectiveDate,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var effectiveDate = this.getNode("Effective Date", effectiveDateNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.DateTime, null);
            topLevelNode.children.push(effectiveDate);

            return topLevelNode;
        }

        private constructTreeNodeForComplexScheduledResource(options: models.TreeItemOptions): any {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelNode = this.getNode(options.text, topLevelString, null, options.variableType, null);

            var topLevelCodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Resource Code",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.Code,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_Id,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelCodeNode = this.getNode("Resource Code", topLevelCodeString, null, options.variableType, null);
            topLevelNode.children.push(topLevelCodeNode);

            var shortDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Short Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_ShortDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var shortDescriptionNode = this.getNode("Short Description", shortDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelCodeNode.children.push(shortDescriptionNode);

            var longDescriptionNodeString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Long Description",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_Code_LongDescription,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var longDescriptionNode = this.getNode("Long Description", longDescriptionNodeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null);
            topLevelCodeNode.children.push(longDescriptionNode);

            var beginDateString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Begin Date",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_BeginDate,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var beginDateNode = this.getNode("Begin Date", beginDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.DateTime, null);
            topLevelNode.children.push(beginDateNode);

            var endDateString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "End Date",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheduledResource_EndDate,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var endDateNode = this.getNode("End Date", endDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.DateTime, null);
            topLevelNode.children.push(endDateNode);

            var isBookedString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                "Is Booked",
                options.treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.Boolean,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ScheudledResource_IsBooked,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var isBookedNode = this.getNode("Is Booked", isBookedString, null, Wars.Domain.Model.Codes.Enums.VariableType.Boolean, null);
            topLevelNode.children.push(isBookedNode);

            return topLevelNode;
        }

        private constructTreeNodeForComplexDateTime(options: models.TreeItemOptions): any {
            var topLevelString: string = this.getTreeItemStringWithAllParmeters(
                options.id,
                options.text,
                options.treeItemSource,
                options.variableType,
                options.isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_DateTime,
                options.listSectionId,
                options.isClaimWithValue,
                options.queryConfigurationId,
                options.placeholder,
                options.isRequired,
                options.isPlaceholderList,
                options.userClaimDefinitionId,
                options.interProcessApiId);

            var topLevelNode = this.getNode(options.text, topLevelString, null, options.variableType, null);

            if (options.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                options.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {

                var shortDateString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Short Date",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDate,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var shortDateNode = this.getNode("Short Date", shortDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009");
                topLevelNode.children.push(shortDateNode);

                var longDateString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Long Date",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDate,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var longDateNode = this.getNode("Long Date", longDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009");
                topLevelNode.children.push(longDateNode);
            }

            if (options.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {
                var shortDateShortTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Short Date/Short Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateShortTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var shortDateShortTimeNode = this.getNode("Short Date/Short Time", shortDateShortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009 1:45 PM");
                topLevelNode.children.push(shortDateShortTimeNode);

                var shortDateLongTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Short Date/Long Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateLongTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var shortDateLongTimeNode = this.getNode("Short Date/Long Time", shortDateLongTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009 1:45:30 PM");
                topLevelNode.children.push(shortDateLongTimeNode);

                var longDateShortTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Long Date/Short Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateShortTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var longDateShortTimeNode = this.getNode("Long Date/Short Time", longDateShortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009 1:45 PM");
                topLevelNode.children.push(longDateShortTimeNode);

                var longDateLongTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Long Date/Long Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateLongTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var longDateLongTimeNode = this.getNode("Long Date/Long Time", longDateLongTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009 1:45:30 PM");
                topLevelNode.children.push(longDateLongTimeNode);
            }

            if (options.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Time ||
                options.variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {
                var shortTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Short Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var shortTimeNode = this.getNode("Short Time", shortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "1:45 PM");
                topLevelNode.children.push(shortTimeNode);

                var longTimeString: string = this.getTreeItemStringWithAllParmeters(
                    options.id,
                    "Long Time",
                    options.treeItemSource,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    options.isSystemLevel,
                    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongTime,
                    options.listSectionId,
                    options.isClaimWithValue,
                    options.queryConfigurationId,
                    options.placeholder,
                    options.isRequired,
                    options.isPlaceholderList,
                    options.userClaimDefinitionId,
                    options.interProcessApiId);

                var longTimeNode = this.getNode("Long Time", longTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "1:45:30 PM");
                topLevelNode.children.push(longTimeNode);
            }

            return topLevelNode;
        }

        private constructTreeClaimGroupNode(
            property: Wars.Domain.Model.ClaimGroup,
            isSystemLevel: boolean,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource): any {
            var stringified: string = this.getTreeItemStringWithAllParmeters(
                property.id,
                property.name,
                treeItemSource,
                Wars.Domain.Model.Codes.Enums.VariableType.ClaimGroup,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Code_Id);

            return this.getNode(property.name, stringified, null, Wars.Domain.Model.Codes.Enums.VariableType.ClaimGroup, null);
        }

        private constructTreeEmailGroupNode(emailGroup: Wars.Domain.Model.EmailGroup, isSystemLevel: boolean) {
            var stringified: string = this.getTreeItemStringWithAllParmeters(
                emailGroup.id,
                emailGroup.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.EmailGroup,
                Wars.Domain.Model.Codes.Enums.VariableType.EmailGroup, // Email Group GUID
                isSystemLevel);

            return this.getNode(emailGroup.name, stringified, "glyphicon-envelope", null, null);
        }


        private constructTreeDocumentNode(document: Wars.Domain.Model.StaticDocument, isSystemLevel: boolean) {
            var stringified: string = this.getTreeItemStringWithAllParmeters(
                document.id,
                document.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.Document,
                Wars.Domain.Model.Codes.Enums.VariableType.Document, // Document Metadata GUID
                isSystemLevel);

            return this.getNode(document.name, stringified, "glyphicon-file", null, null);
        }

        private setQuerySchemaNodes(schema: Wars.Domain.Model.ObjectSchema, topNode: any, queryConfigId: string, listSectionId: string, isSystemLevel: boolean) {
            if (!schema || !schema.properties) return;
            schema.properties.forEach(prop => {
                var node;

                if (prop.typeSchema) {
                    node = this.getTopNode(prop.name, false, prop.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List ? "glyphicon-th-list" : "glyphicon-certificate");
                    this.setQuerySchemaNodes(prop.typeSchema, node, queryConfigId, undefined, isSystemLevel);
                }
                else {
                    node = this.constructTreeQueryDataNode(prop, queryConfigId, listSectionId, isSystemLevel);
                }

                topNode.children.push(node);
            });
        }

        private setSchemaNodes(
            schema: Wars.Domain.Model.ObjectSchema,
            topNode: any,
            listSectionId: string,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource,
            isSystemLevel: boolean,
            itemIcon?: string,
            interProcessApiId?: string): void
        {
            if (!schema || !schema.properties) return;
            schema.properties.forEach(prop => {
                if (!this.scope.isReporting || (this.scope.isReporting && prop.isIndexed)) {
                    var node;

                    if (prop.typeSchema) {
                        node = this.getTopNode(prop.name, false, prop.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List ? "glyphicon-th-list" : itemIcon);
                        this.setSchemaNodes(prop.typeSchema, node, prop.typeSchema.id, treeItemSource, isSystemLevel, itemIcon);
                    }
                    else {
                        node = this.constructTreePropertySchemaNode(prop, listSectionId, treeItemSource, isSystemLevel, null, interProcessApiId);
                    }

                    topNode.children.push(node);
                }
            });
        }

        private setQueryNodes(queries: Wars.Domain.Model.QueryConfiguration[], topNode: any, isSystemLevel: boolean) {
            if (queries) {
                Enumerable.from(queries).orderBy(i => i.name).forEach(queryConfig => {
                    var queryNode = this.getTopNode(queryConfig.name, false, queryConfig.myDataOperation.isArrayResult ? "glyphicon-th-list" : "glyphicon-question-sign");

                    this.setQuerySchemaNodes(queryConfig.myDataOperation.resultSchema, queryNode, queryConfig.id, undefined, isSystemLevel);

                    topNode.children.push(queryNode);
                });
            }
        }

        private setClaimGroupNodes(claimGroups: Wars.Domain.Model.ClaimGroup[], topNode: any, isSystemLevel: boolean) {
            if (claimGroups) {
                Enumerable.from(claimGroups).orderBy(i => i.name).forEach(claimGroup => {
                    var claimGroupNode = this.constructTreeClaimGroupNode(claimGroup, isSystemLevel, Wars.Domain.Model.Codes.Enums.TreeItemSource.ClaimGroup);
                    topNode.children.push(claimGroupNode);
                });
            }
        }

        private setEmailGroupNodes(emailGroups: Wars.Domain.Model.EmailGroup[], topNode: any, isSystemLevel: boolean) {
            if (emailGroups) {
                Enumerable.from(emailGroups).orderBy(i => i.name).forEach(emailGroup => {
                    var emailGroupNode = this.constructTreeEmailGroupNode(emailGroup, isSystemLevel);
                    topNode.children.push(emailGroupNode);
                });
            }
        }

        private setStaticDocumentNodes(staticDocuments: Wars.Domain.Model.StaticDocument[], topNode: any, isSystemLevel: boolean) {
            if (staticDocuments) {
                Enumerable.from(staticDocuments).orderBy(i => i.name).forEach(staticDocument => {
                    var staticDocumentNode = this.constructTreeDocumentNode(staticDocument, isSystemLevel);
                    topNode.children.push(staticDocumentNode);
                });
            }
        }

        private getTopNode(name: string, isOpen: Boolean, glyphicon?: string): any {
            var topNode = {
                text: name,
                state: {
                    opened: isOpen
                },
                children: [],
                icon: null
            };

            if (glyphicon) {
                topNode.icon = "glyphicon " + glyphicon;
            }

            return topNode;
        }

        private getNode(
            text: string,
            treeItemStringified: string,
            glyphicon: string,
            variableType?: Wars.Domain.Model.Codes.Enums.VariableType,
            fieldType?: Wars.Domain.Model.Codes.Enums.FieldType,
            title?: string): any {
            let icon = "";

            if (variableType !== undefined && variableType !== null) {
                icon = this.getIconForVariableType(variableType);
            }
            else if (fieldType !== undefined && fieldType !== null) {
                icon = this.getIconForFieldType(fieldType);
            }
            else if (glyphicon) {
                icon = `glyphicon ${glyphicon}`;
            }

            var node = {
                text: text,
                icon: icon,
                li_attr: {
                    ondragstart: "localStorage.setItem('treeDrag','" + ProcessConfigurationTree.encodeStringifiedTreeItem(treeItemStringified) + "');event.stopPropagation();",
                    warsInfo: treeItemStringified,
                    draggable: true,
                    title: title
                },
                children: []
            };

            return node;
        }

        private isProcessTopLevelAllowed(): boolean {
            if (!this.restrictionsDefined || this.processSectionAllowed) return true;
            return false;
        }

        private isSystemTopLevelAllowed(): boolean {
            if (!this.restrictionsDefined || this.systemSectionsAllowed) return true;
            return false;
        }

        private isProcessSectionAllowed(sectionType: string): boolean {
            return !this.restrictionsDefined ||
                !this.processSectionAllowed || this.processSectionAllowed.length === 0 ||
                this.processSectionAllowed.indexOf(sectionType) !== -1;
        }

        private isSystemSectionAllowed(sectionType: string): boolean {
            return !this.restrictionsDefined ||
                this.systemSectionsAllowed.length === 0 || this.systemSectionsAllowed.indexOf(sectionType) !== -1;
        }

        private getTreeItemStringWithAllParmeters(
            id: string,
            text: string,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty,
            listSectionId?: string,
            isClaimWithValue?: boolean,
            queryConfigurationId?: string,
            placeholder?: Wars.Domain.Model.Codes.Enums.Placeholder,
            isRequired?: boolean,
            isPlaceholderList?: boolean,
            userClaimDefinitionId?: string,
            interProcessApiId?: string): string
        {
            var options = new models.TreeItemOptions(
                id,
                text,
                treeItemSource,
                variableType,
                isSystemLevel);

            options.complexObjectProperty = complexObjectProperty;
            options.listSectionId = listSectionId;
            options.isClaimWithValue = isClaimWithValue;
            options.queryConfigurationId = queryConfigurationId;
            options.placeholder = placeholder;
            options.isRequired = isRequired;
            options.isPlaceholderList = isPlaceholderList;
            options.userClaimDefinitionId = userClaimDefinitionId;
            options.interProcessApiId = interProcessApiId;

            return this.getTreeItemString(options);
        }

        private getTreeItemString(treeItemOptions: models.TreeItemOptions): string {

            var treeConfigurationItem: models.TreeConfigurationItem = new models.TreeConfigurationItem();

            treeConfigurationItem.variableType = treeItemOptions.variableType;
            treeConfigurationItem.isClaimWithValue = treeItemOptions.isClaimWithValue !== undefined && treeItemOptions.isClaimWithValue;
            treeConfigurationItem.treeItemSource = treeItemOptions.treeItemSource;
            treeConfigurationItem.isSystemLevel = treeItemOptions.isSystemLevel;
            treeConfigurationItem.isList = treeItemOptions.listSectionId !== undefined || (treeItemOptions.isPlaceholderList === true);
            treeConfigurationItem.text = treeItemOptions.text;
            treeConfigurationItem.isRequired = !(treeItemOptions.isRequired === undefined || treeItemOptions.isRequired === false);
            treeConfigurationItem.complexObjectProperty = treeItemOptions.complexObjectProperty;
            treeConfigurationItem.userClaimDefinitionId = treeItemOptions.userClaimDefinitionId;
            treeConfigurationItem.claimUniqueId = treeItemOptions.claimUniqueId;

            switch (treeItemOptions.treeItemSource) {
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation:
                    treeConfigurationItem.calculationId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Claim:
                    treeConfigurationItem.claimId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Condition:
                    treeConfigurationItem.conditionId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant:
                    treeConfigurationItem.constantId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Document:
                    treeConfigurationItem.staticDocumentId = treeItemOptions.id;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.Document;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.EmailGroup:
                    treeConfigurationItem.emailGroupId = treeItemOptions.id;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.EmailGroup;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField:
                    if (treeConfigurationItem.isList) {
                        treeConfigurationItem.listSectionId = treeItemOptions.listSectionId;
                        treeConfigurationItem.listPropertyId = treeItemOptions.id;
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    } else {
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    }

                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.OperationParameter:
                    treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Query:
                    treeConfigurationItem.queryId = treeItemOptions.queryConfigurationId;
                    treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.Query;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Step:
                    treeConfigurationItem.stepId = treeItemOptions.id;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.Step;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable:
                    if (treeConfigurationItem.isList) {
                        treeConfigurationItem.listSectionId = treeItemOptions.listSectionId;
                        treeConfigurationItem.listPropertyId = treeItemOptions.id;
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    } else {
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder:
                    treeConfigurationItem.placeholder = treeItemOptions.placeholder;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker:
                    treeConfigurationItem.timeTrackerId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.CodeGroup:
                    treeConfigurationItem.systemCodeId = treeItemOptions.id;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.ClaimGroup:
                    treeConfigurationItem.claimGroupId = treeItemOptions.id;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.ClaimGroup;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.InterProcessApi:
                    if (treeConfigurationItem.isList) {
                        treeConfigurationItem.listSectionId = treeItemOptions.listSectionId;
                        treeConfigurationItem.listPropertyId = treeItemOptions.id;
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    } else {
                        treeConfigurationItem.schemaPropertyId = treeItemOptions.id;
                    }
                    treeConfigurationItem.interProcessApiId = treeItemOptions.interProcessApiId;
                    treeConfigurationItem.treeItemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.InterProcessApi;
                    break;
                case Wars.Domain.Model.Codes.Enums.TreeItemSource.RelatedClaim:
                    treeConfigurationItem.relatedClaimProcessTypeId = treeItemOptions.id;
                    break;
                default:
                    alert("Do not recognize this tree item source: " + treeItemOptions.treeItemSource);
                    break;
            }

            return JSON.stringify(treeConfigurationItem);
        }

        private constructTreeConstantNode(constant: Wars.Domain.Model.ConstantValue, isSystemLevel: boolean): any {
            var options = new models.TreeItemOptions(
                constant.id,
                constant.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant,
                constant.variableType,
                isSystemLevel);

            var str: string = this.getTreeItemString(options);

            return this.getNode(constant.name, str, null, constant.variableType, null);
        }

        private constructTreeCodeGroupNode(codeGroup: Wars.Domain.Model.Codes.CodeGroup, isSystemLevel: boolean): any {
            var options = new models.TreeItemOptions(
                codeGroup.id,
                codeGroup.groupName,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.CodeGroup,
                Wars.Domain.Model.Codes.Enums.VariableType.Code, //TODO - Kevin should this be something else?
                isSystemLevel);
        
            var codeGroupStringified: string = this.getTreeItemString(options);

            return this.getNode(codeGroup.groupName, codeGroupStringified, null, null);
        }

        private constructTreeConditionNode(condition: Wars.Domain.Model.Conditions.Condition, isSystemLevel: boolean): any {
            var options = new models.TreeItemOptions(
                condition.id,
                condition.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.Condition,
                Wars.Domain.Model.Codes.Enums.VariableType.Boolean,
                isSystemLevel);

            var conditionStringified: string = this.getTreeItemString(options);
               
            return this.getNode(condition.name, conditionStringified, "glyphicon-copyright-mark", null, null);
        }

        private constructTreeCalcuationNode(calculation: Wars.Domain.Model.Calculations.Calculation, isSystemLevel: boolean): any {
            var options = new models.TreeItemOptions(
                calculation.id,
                calculation.name,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation,
                calculation.valueOperation.variableType,
                isSystemLevel);

            options.isPlaceholderList = calculation.isList;

            var calculationStringified: string = this.getTreeItemString(options);
                
            return this.getNode(calculation.name, calculationStringified, "glyphicon-superscript", null, null);
        }

        private getIconForFieldType(variableType: Wars.Domain.Model.Codes.Enums.FieldType): string {
            var icon: string;
            switch (variableType) {
                case Wars.Domain.Model.Codes.Enums.FieldType.TextBox:
                case Wars.Domain.Model.Codes.Enums.FieldType.TextArea:
                case Wars.Domain.Model.Codes.Enums.FieldType.Zipcode:
                case Wars.Domain.Model.Codes.Enums.FieldType.EmailAddress:
                case Wars.Domain.Model.Codes.Enums.FieldType.Url:
                    icon = "glyphicon glyphicon-text-width";
                    break;

                case Wars.Domain.Model.Codes.Enums.FieldType.Number:
                    icon = "glyphicon glyphicon-italic";
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.PhoneNumber:
                    icon = "glyphicon glyphicon-earphone";
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Date:
                case Wars.Domain.Model.Codes.Enums.FieldType.Time:
                    icon = "glyphicon glyphicon-calendar";
                    break;

                case Wars.Domain.Model.Codes.Enums.FieldType.CheckBox:
                    icon = "glyphicon glyphicon-check";
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.Currency:
                    icon = "glyphicon glyphicon-usd";
                    break;
                case Wars.Domain.Model.Codes.Enums.FieldType.DocumentUpload:
                    icon = "glyphicon glyphicon-paperclip";
                    break;
                default:
                    icon = "glyphicon glyphicon-pencil";
            }
            return icon;
        }

        private getIconForVariableType(variableType: Wars.Domain.Model.Codes.Enums.VariableType): string {
            var icon: string;
            switch (variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                    icon = "glyphicon glyphicon-text-width";
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                    icon = "glyphicon glyphicon-italic";
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    icon = "glyphicon glyphicon-sound-5-1";
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                    icon = "glyphicon glyphicon-calendar";
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
                    icon = "glyphicon glyphicon-check";
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.List:
                    icon = "glyphicon glyphicon-th-list";
                    break;

                default:
                    icon = "glyphicon glyphicon-asterisk";
            }
            return icon;
        }

        private getPlaceholderTreeItemString(
            label: string,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty,
            isList?: boolean,
            userClaimDefinitionId?: string): string {

            var options = new models.TreeItemOptions(
                "0",
                label,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                variableType,
                isSystemLevel);

            options.complexObjectProperty = complexObjectProperty;
            options.placeholder = placeholder;
            options.isPlaceholderList = isList;
            options.userClaimDefinitionId = userClaimDefinitionId;

            return this.getTreeItemString(options);
        }

        private createNewPlaceHolderTreeNode(
            label: string,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty,
            isList?: boolean,
            userClaimDefinitionId?: string): any
        {
            var placeHolderString = this.getPlaceholderTreeItemString(
                label,
                variableType,
                isSystemLevel,
                placeholder,
                complexObjectProperty,
                isList,
                userClaimDefinitionId);

            return this.getNode(label, placeHolderString, undefined, variableType, null);
        }

        private addNewPlaceholderTreeNode(
            parentNode: any,
            label: string,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty,
            isList?: boolean,
            userClaimDefinitionId?: string): any {

            var newPlaceholderNode = this.createNewPlaceHolderTreeNode(
                label,
                variableType,
                isSystemLevel,
                placeholder,
                complexObjectProperty,
                isList,
                userClaimDefinitionId);

            parentNode.children.push(newPlaceholderNode);

            return newPlaceholderNode;
        }

        private addPlaceholderUserNodes(
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            isSystemLevel: boolean,
            parentNode: any): void {

            var topNodeName = placeholder === Wars.Domain.Model.Codes.Enums.Placeholder.CurrentUser
                ? "Current User"
                : "Process Initiator";

            var userTopLevelNode = this.addNewPlaceholderTreeNode(
                parentNode,
                topNodeName,
                Wars.Domain.Model.Codes.Enums.VariableType.User,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Id);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Username",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_UserName);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "First Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FirstName);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Middle Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_MiddleName);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Last Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_LastName);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Full Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_FullName);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Email",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Email);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Company",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Company);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Phone Number",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_PhoneNumber);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Position",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Position);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "External System Identifier",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ExternalSystemId);

            this.addNewPlaceholderTreeNode(
                userTopLevelNode,
                "Claims",
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_Claims,
                true);

            var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
                .where(i => i.codeGroup_id !== null)
                .toArray();

            if (claimsWithValues.length > 0) {

                var userClaimValueTopLevel = this.getTopNode("Claim Values", false);
                userTopLevelNode.children.push(userClaimValueTopLevel);

                for (var i = 0; i < claimsWithValues.length; i++) {
                    this.addNewPlaceholderTreeNode(
                        userClaimValueTopLevel,
                        claimsWithValues[i].type,
                        Wars.Domain.Model.Codes.Enums.VariableType.List,
                        isSystemLevel,
                        placeholder,
                        Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.User_ClaimValues,
                        true,
                        claimsWithValues[i].id);
                }
            }
        }

        private addPlaceholderReviewNodes(
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            isSystemLevel: boolean,
            parentNode: any): void {

            var topNodeName = "Current Review";

            var reviewTopLevelNode = this.addNewPlaceholderTreeNode(
                parentNode,
                topNodeName,
                Wars.Domain.Model.Codes.Enums.VariableType.Review,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Id);

            this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Comment",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Comment);

            this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Is Complete",
                Wars.Domain.Model.Codes.Enums.VariableType.Boolean,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_IsComplete);

            this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Assigned Date",
                Wars.Domain.Model.Codes.Enums.VariableType.Date,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignedDate);

            this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Due Date",
                Wars.Domain.Model.Codes.Enums.VariableType.Date,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_DueDate);

            this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Closed Date",
                Wars.Domain.Model.Codes.Enums.VariableType.Date,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_ClosedDate);

            var reviewTypeLevelNode =this.addNewPlaceholderTreeNode(
                reviewTopLevelNode,
                "Review Type",
                Wars.Domain.Model.Codes.Enums.VariableType.Code,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Type_Id);

            this.addNewPlaceholderTreeNode(
                reviewTypeLevelNode,
                "Short Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Type_ShortDescription);

            this.addNewPlaceholderTreeNode(
                reviewTypeLevelNode,
                "Long Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Type_LongDescription);

            var assigneeNode = this.getTopNode("Assignee", false);
            var assignorNode = this.getTopNode("Assignor", false);

            reviewTopLevelNode.children.push(assigneeNode);
            reviewTopLevelNode.children.push(assignorNode);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Assigned User",
                Wars.Domain.Model.Codes.Enums.VariableType.User,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignedUser_Id,
                true);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "First Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_FirstName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Middle Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_MiddleName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Last Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_LastName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Full Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_FullName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Email",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Email);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Company",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Company);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Phone Number",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_PhoneNumber);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Position",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Position);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Claims",
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_Claims,
                true);

            var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
                .where(i => i.codeGroup_id !== null)
                .toArray();

            if (claimsWithValues.length > 0) {

                let userClaimValueTopLevel = this.getTopNode("Claim Values", false);
                assigneeNode.children.push(userClaimValueTopLevel);

                for (var i = 0; i < claimsWithValues.length; i++) {
                    this.addNewPlaceholderTreeNode(
                        userClaimValueTopLevel,
                        claimsWithValues[i].type,
                        Wars.Domain.Model.Codes.Enums.VariableType.List,
                        isSystemLevel,
                        placeholder,
                        Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignee_ClaimValues,
                        true,
                        claimsWithValues[i].id);
                }
            }



            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Assignor User",
                Wars.Domain.Model.Codes.Enums.VariableType.User,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignorUser_Id,
                true);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "First Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_FirstName);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Middle Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_MiddleName);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Last Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_LastName);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Full Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_FullName);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Email",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Email);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Company",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Company);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Phone Number",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_PhoneNumber);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Position",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Position);

            this.addNewPlaceholderTreeNode(
                assignorNode,
                "Claims",
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_Claims,
                true);

            var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
                .where(i => i.codeGroup_id !== null)
                .toArray();

            if (claimsWithValues.length > 0) {

                let userClaimValueTopLevel = this.getTopNode("Claim Values", false);
                assignorNode.children.push(userClaimValueTopLevel);

                for (var i = 0; i < claimsWithValues.length; i++) {
                    this.addNewPlaceholderTreeNode(
                        userClaimValueTopLevel,
                        claimsWithValues[i].type,
                        Wars.Domain.Model.Codes.Enums.VariableType.List,
                        isSystemLevel,
                        placeholder,
                        Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_Assignor_ClaimValues,
                        true,
                        claimsWithValues[i].id);
                }
            }

            //this.addNewPlaceholderTreeNode(
            //    reviewTopLevelNode,
            //    "Assigned User",
            //    Wars.Domain.Model.Codes.Enums.VariableType.User,
            //    isSystemLevel,
            //    placeholder,
            //    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignedUser_Id,
            //    true);

            //this.addNewPlaceholderTreeNode(
            //    reviewTopLevelNode,
            //    "Assignor User",
            //    Wars.Domain.Model.Codes.Enums.VariableType.User,
            //    isSystemLevel,
            //    placeholder,
            //    Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Review_AssignorUser_Id,
            //    true);
        }

        private addPlaceholderAssignmentNodes(
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            isSystemLevel: boolean,
            parentNode: any): void {

            var topNodeName = "Current Assignment";

            var assignmentTopLevelNode = this.addNewPlaceholderTreeNode(
                parentNode,
                topNodeName,
                Wars.Domain.Model.Codes.Enums.VariableType.Assignment,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Id);

            var assigneeNode = this.getTopNode("Assignee", false);
            var assignorNode = this.getTopNode("Assignor", false);

            assignmentTopLevelNode.children.push(assigneeNode);
            assignmentTopLevelNode.children.push(assignorNode);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Assigned User",
                Wars.Domain.Model.Codes.Enums.VariableType.User,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Id,
                true);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "First Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_FirstName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Middle Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_MiddleName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Last Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_LastName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Full Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_FullName);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Email",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Email);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Company",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Company);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Phone Number",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_PhoneNumber);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Position",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Position);

            this.addNewPlaceholderTreeNode(
                assigneeNode,
                "Claims",
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_Claims,
                true);

            var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
                .where(i => i.codeGroup_id !== null)
                .toArray();

            if (claimsWithValues.length > 0) {

                let userClaimValueTopLevel = this.getTopNode("Claim Values", false);
                assigneeNode.children.push(userClaimValueTopLevel);

                for (var i = 0; i < claimsWithValues.length; i++) {
                    this.addNewPlaceholderTreeNode(
                        userClaimValueTopLevel,
                        claimsWithValues[i].type,
                        Wars.Domain.Model.Codes.Enums.VariableType.List,
                        isSystemLevel,
                        placeholder,
                        Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignee_ClaimValues,
                        true,
                        claimsWithValues[i].id);
                }
            }



           this.addNewPlaceholderTreeNode(
               assignorNode,
                "Assignor User",
                Wars.Domain.Model.Codes.Enums.VariableType.User,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Id,
                true);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "First Name",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_FirstName);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Middle Name",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_MiddleName);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Last Name",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_LastName);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Full Name",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_FullName);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Email",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Email);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Company",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Company);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Phone Number",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_PhoneNumber);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Position",
               Wars.Domain.Model.Codes.Enums.VariableType.String,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Position);

           this.addNewPlaceholderTreeNode(
               assignorNode,
               "Claims",
               Wars.Domain.Model.Codes.Enums.VariableType.List,
               isSystemLevel,
               placeholder,
               Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_Claims,
               true);

           var claimsWithValues = Enumerable.from(this.scope.systemLevel.myClaims)
               .where(i => i.codeGroup_id !== null)
               .toArray();

           if (claimsWithValues.length > 0) {

               let userClaimValueTopLevel = this.getTopNode("Claim Values", false);
               assignorNode.children.push(userClaimValueTopLevel);

               for (var i = 0; i < claimsWithValues.length; i++) {
                   this.addNewPlaceholderTreeNode(
                       userClaimValueTopLevel,
                       claimsWithValues[i].type,
                       Wars.Domain.Model.Codes.Enums.VariableType.List,
                       isSystemLevel,
                       placeholder,
                       Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Assignment_Assignor_ClaimValues,
                       true,
                       claimsWithValues[i].id);
               }
           }
        }

        private addPlaceholderUserActionNodes(
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            isSystemLevel: boolean,
            parentNode: any): void {

            var userActionTopLevelNode = this.getTopNode("Current User Action", false);
            parentNode.children.push(userActionTopLevelNode);

            this.addNewPlaceholderTreeNode(
                userActionTopLevelNode,
                "Comment",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_Comment);

            this.addNewPlaceholderTreeNode(
                userActionTopLevelNode,
                "Uploaded Attachments",
                Wars.Domain.Model.Codes.Enums.VariableType.Document,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_Documents,
                true);

            this.addNewPlaceholderDateTimeNodes(
                userActionTopLevelNode,
                "Effective Date",
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.UserAction_EffectiveDate);
        }

        private addPlaceholderProcessEventNodes(
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            isSystemLevel: boolean,
            parentNode: any): void {

            var userActionTopLevelNode = this.getTopNode("Current Process Event", false);
            parentNode.children.push(userActionTopLevelNode);

            this.addNewPlaceholderTreeNode(
                userActionTopLevelNode,
                "Comment",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ProcessEvent_Comment);

            this.addNewPlaceholderTreeNode(
                userActionTopLevelNode,
                "Uploaded Attachments",
                Wars.Domain.Model.Codes.Enums.VariableType.Document,
                isSystemLevel,
                placeholder,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.ProcessEvent_Documents,
                true);
        }

        private addNewCodeGroupTreeNode(
            parentNode: any,
            label: string,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty,
            isList?: boolean): any {

            var newPlaceholderNode = this.createNewPlaceHolderTreeNode(
                label,
                variableType,
                isSystemLevel,
                placeholder,
                complexObjectProperty,
                isList);

            parentNode.children.push(newPlaceholderNode);

            return newPlaceholderNode;
        }

        addNewPlaceholderDateTimeNodes(
            parentNode: any,
            label: string,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean,
            placeholder: Wars.Domain.Model.Codes.Enums.Placeholder,
            complexObjectProperty: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty): void {

            var topLevelOptions = new models.TreeItemOptions(
                undefined,
                label,
                Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                variableType,
                isSystemLevel);

            topLevelOptions.complexObjectProperty = complexObjectProperty;
            topLevelOptions.placeholder = placeholder;

            var topLevelString: string = this.getTreeItemString(topLevelOptions);


            var topLevelNode = this.getNode(label, topLevelString, null, variableType, null);

            if (variableType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {

                var dateOptions = new models.TreeItemOptions(
                    undefined,
                    "Short Date",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);

                dateOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDate;
                dateOptions.placeholder = placeholder;

                var shortDateString: string = this.getTreeItemString(dateOptions);

                var shortDateNode = this.getNode("Short Date", shortDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009");
                topLevelNode.children.push(shortDateNode);

                var longDateOptions = new models.TreeItemOptions(
                    undefined,
                    "Long Date",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);

                longDateOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDate;
                longDateOptions.placeholder = placeholder;

                var longDateString: string = this.getTreeItemString(longDateOptions);
                
                var longDateNode = this.getNode("Long Date", longDateString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009");
                topLevelNode.children.push(longDateNode);
            }

            if (variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {
                var shortDateShortTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Short Date/Short Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);

                shortDateShortTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateShortTime;
                shortDateShortTimeOptions.placeholder = placeholder;

                var shortDateShortTimeString: string = this.getTreeItemString(shortDateShortTimeOptions);
                    
                var shortDateShortTimeNode = this.getNode("Short Date/Short Time", shortDateShortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009 1:45 PM");
                topLevelNode.children.push(shortDateShortTimeNode);

                var shortDateLongTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Short Date/Long Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);
                shortDateLongTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortDateLongTime;
                shortDateLongTimeOptions.placeholder = placeholder;

                var shortDateLongTimeString: string = this.getTreeItemString(shortDateLongTimeOptions);
                   

                var shortDateLongTimeNode = this.getNode("Short Date/Long Time", shortDateLongTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "6/15/2009 1:45:30 PM");
                topLevelNode.children.push(shortDateLongTimeNode);

                var longDateShortTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Long Date/Short Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);
                longDateShortTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateShortTime;
                longDateShortTimeOptions.placeholder = placeholder;

                var longDateShortTimeString: string = this.getTreeItemString(longDateShortTimeOptions);
                   

                var longDateShortTimeNode = this.getNode("Long Date/Short Time", longDateShortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009 1:45 PM");
                topLevelNode.children.push(longDateShortTimeNode);

                var longDateLongTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Long Date/Long Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);
                longDateLongTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongDateLongTime;
                longDateLongTimeOptions.placeholder = placeholder;

                var longDateLongTimeString: string = this.getTreeItemString(longDateLongTimeOptions);

                var longDateLongTimeNode = this.getNode("Long Date/Long Time", longDateLongTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "Monday, June 15, 2009 1:45:30 PM");
                topLevelNode.children.push(longDateLongTimeNode);
            }

            if (variableType === Wars.Domain.Model.Codes.Enums.VariableType.Time ||
                variableType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime) {

                var shortTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Short Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);
                shortTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_ShortTime;
                shortTimeOptions.placeholder = placeholder;

                var shortTimeString: string = this.getTreeItemString(shortTimeOptions);

                var shortTimeNode = this.getNode("Short Time", shortTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "1:45 PM");
                topLevelNode.children.push(shortTimeNode);

                var longTimeOptions = new models.TreeItemOptions(
                    undefined,
                    "Long Time",
                    Wars.Domain.Model.Codes.Enums.TreeItemSource.PlaceHolder,
                    Wars.Domain.Model.Codes.Enums.VariableType.String,
                    isSystemLevel);
                longTimeOptions.complexObjectProperty = Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_LongTime;
                longTimeOptions.placeholder = placeholder;

                var longTimeString: string = this.getTreeItemString(longTimeOptions);

                var longTimeNode = this.getNode("Long Time", longTimeString, null, Wars.Domain.Model.Codes.Enums.VariableType.String, null, "1:45:30 PM");
                topLevelNode.children.push(longTimeNode);
            }

            parentNode.children.push(topLevelNode);
        }

        private setCodeGroupValues(node: any, isSystemLevel: boolean) {
            //var formattingTopLevel = this.getTopNode("Formatting", false);
            //node.children.push(formattingTopLevel);
        }

        private setPlaceHolderValues(node: any, isSystemLevel: boolean) {

            var formattingTopLevel = this.getTopNode("Formatting", false);
            node.children.push(formattingTopLevel);

            this.addPlaceholderUserActionNodes(Wars.Domain.Model.Codes.Enums.Placeholder.UserAction, isSystemLevel, node);
            this.addPlaceholderProcessEventNodes(Wars.Domain.Model.Codes.Enums.Placeholder.ProcessEvent, isSystemLevel, node);

            this.addNewPlaceholderTreeNode(
                formattingTopLevel,
                "New Line",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.NewLine);

            this.addNewPlaceholderTreeNode(
                formattingTopLevel,
                "Space",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.Space);

            this.addNewPlaceholderTreeNode(
                formattingTopLevel,
                "Tab",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.Tab);

            this.addNewPlaceholderTreeNode(
                formattingTopLevel,
                "Empty",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.Empty);

            this.addNewPlaceholderTreeNode(
                node,
                "Current Year",
                Wars.Domain.Model.Codes.Enums.VariableType.Integer,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentYear);

            this.addNewPlaceholderDateTimeNodes(
                node,
                "Current Date Time",
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentDateTime,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.DateTime_DateTime
            );

            var currentStatusNode = this.addNewPlaceholderTreeNode(
                node,
                "Current Status",
                Wars.Domain.Model.Codes.Enums.VariableType.Status,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentStatus,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_Id);
            this.addNewPlaceholderTreeNode(
                currentStatusNode,
                "Short Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentStatus,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_ShortDescription);

            this.addNewPlaceholderTreeNode(
                currentStatusNode,
                "Long Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentStatus,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_LongDescription);

            this.addNewPlaceholderTreeNode(
                currentStatusNode,
                "Effective Date",
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentStatus,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.Status_EffectiveDate);

            var currentSubTypeNode = this.addNewPlaceholderTreeNode(
                node,
                "Current SubType",
                Wars.Domain.Model.Codes.Enums.VariableType.SubType,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentSubType,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_Id);

            this.addNewPlaceholderTreeNode(
                currentSubTypeNode,
                "Name",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentSubType,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_Name);

            this.addNewPlaceholderTreeNode(
                currentSubTypeNode,
                "Display Name",
                Wars.Domain.Model.Codes.Enums.VariableType.SubType,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentSubType,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.SubType_DisplayName);

            var currentStateNode = this.addNewPlaceholderTreeNode(
                node,
                "Current State",
                Wars.Domain.Model.Codes.Enums.VariableType.State,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentState,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_Id);

            this.addNewPlaceholderTreeNode(
                currentStateNode,
                "Short Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentState,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_ShortDescription);

            this.addNewPlaceholderTreeNode(
                currentStateNode,
                "Long Description",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentState,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_LongDescription);

            this.addNewPlaceholderTreeNode(
                currentStateNode,
                "Effective Date",
                Wars.Domain.Model.Codes.Enums.VariableType.DateTime,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.CurrentState,
                Wars.Domain.Model.Codes.Enums.ComplexObjectProperty.State_EffectiveDate);

            this.addPlaceholderUserNodes(Wars.Domain.Model.Codes.Enums.Placeholder.CurrentUser, isSystemLevel, node);

            this.addNewPlaceholderTreeNode(
                node,
                "Process Identifier",
                Wars.Domain.Model.Codes.Enums.VariableType.Identifier,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.ProcessIdentifier);

            this.addPlaceholderUserNodes(Wars.Domain.Model.Codes.Enums.Placeholder.ProcessInitiator, isSystemLevel, node);

            this.addNewPlaceholderTreeNode(
                node,
                "Process Type",
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.ProcessType);

            this.addNewPlaceholderTreeNode(
                node,
                "All Selected Documents",
                Wars.Domain.Model.Codes.Enums.VariableType.List,
                isSystemLevel,
                Wars.Domain.Model.Codes.Enums.Placeholder.AllSelectedDocuments,
                undefined,
                true);

            this.addPlaceholderReviewNodes(Wars.Domain.Model.Codes.Enums.Placeholder.Review, isSystemLevel, node);
            this.addPlaceholderAssignmentNodes(Wars.Domain.Model.Codes.Enums.Placeholder.Assignment, isSystemLevel, node);
        }
    }
}

warsApp.registerDirective('ProcessConfigurationTree', []);